export const sidebar = `
<div id="sidebar-loader" style="background-color: #222A2E; height: 100vh; padding: 1rem 0.75rem">
  <div style="display: flex; justify-content: center; margin-top: 2px">
  </div>
</div>
`;
